
function randomRating() {
  return Math.floor(Math.random() * 5) + 1;
}

function randomDate() {
  var now = new Date();
  now.setTime(now.getTime() - Math.random() * 1000 * 60 * 60 * 24 * 30);  // some time in the last month
  return now.getMonth() + '/' + now.getDate() + '/' + now.getFullYear();
}

function randomProvider() {
  let providers = ['Bing', 'Yelp', 'Google', 'Facebook'];
  return providers[Math.floor(Math.random() * providers.length)];
}

var descriptions = [
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus arcu leo, venenatis a eros id, ullamcorper posuere erat. Donec sit amet maximus erat, eget accumsan nisl. Quisque ipsum mauris, ultricies in urna nec, pretium varius lorem. Donec cursus eros est, a tincidunt lorem ultrices vitae. Suspendisse iaculis laoreet nulla in mattis. Ut sed odio eget ex maximus euismod a nec orci. Aenean dictum rhoncus augue, id auctor nulla porttitor in. Ut sed elit lacus.',
  'In at vestibulum nulla. Etiam rutrum, tellus hendrerit iaculis tincidunt, justo quam luctus nisl, vitae volutpat sem sapien eu ante. Praesent sit amet laoreet tortor, commodo facilisis urna. Nullam rutrum dui a arcu fermentum, nec feugiat eros faucibus. Aenean faucibus imperdiet dolor quis blandit. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Morbi mollis id ante eu elementum. Pellentesque volutpat mollis odio vel sodales. Sed non nunc magna. Nulla tempor diam felis, id congue lorem viverra nec. Maecenas lobortis ligula id orci venenatis vestibulum. Quisque dapibus scelerisque lectus, tristique viverra ligula vulputate venenatis. Donec volutpat iaculis quam at lacinia. Aliquam egestas enim id orci bibendum, vel tincidunt neque mollis.',
  'Cras tempor enim congue lorem molestie, id vulputate massa imperdiet. Phasellus id ante dui. Curabitur eu lacus sed leo pellentesque tempus porta eget erat. Morbi vehicula est at ipsum auctor rutrum. Cras aliquam, felis eu blandit sagittis, erat nisi auctor ligula, nec fringilla nisl tortor tempus libero. Phasellus faucibus posuere suscipit. Maecenas sagittis ante turpis, non posuere leo faucibus quis. Sed est nulla, efficitur et sapien in, vulputate cursus nisl. Donec dignissim, metus ac dictum molestie, augue tellus malesuada massa, suscipit tempor ex purus vitae sem. Sed sollicitudin auctor hendrerit. Aliquam in suscipit justo, quis pharetra elit. Cras quis mauris lectus. Maecenas venenatis leo eu auctor consectetur. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Pellentesque imperdiet ipsum ut ante malesuada luctus. Nunc ipsum nulla, fermentum nec sapien vitae, lacinia ultricies nibh.',
  'Donec tristique augue eget nisi iaculis viverra sit amet at felis. Sed ornare tristique tellus sagittis pretium. Quisque fermentum rhoncus purus et pulvinar. Cras laoreet pellentesque purus. Suspendisse accumsan posuere diam quis scelerisque. Aliquam faucibus purus vel sem lacinia, sit amet aliquet ipsum consectetur. Duis sagittis leo elit. Praesent risus ex, posuere quis laoreet in, tempus iaculis odio. Aliquam at eros vel arcu fringilla accumsan.',
  'Cras vehicula gravida enim non sollicitudin. Pellentesque quis tellus porta, sollicitudin nunc a, pulvinar felis. Integer mi augue, pretium ac ullamcorper a, aliquam ut odio. Curabitur erat dolor, tincidunt eu tortor eget, egestas tincidunt sem. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus est lectus, efficitur quis posuere non, dictum quis libero. Duis iaculis vitae sapien sed iaculis. Pellentesque a rhoncus felis. Suspendisse potenti. Morbi scelerisque vel lacus a commodo. Morbi tristique, mauris vitae gravida gravida, dolor orci volutpat velit, nec congue nibh massa non metus. Sed gravida eget orci sit amet rhoncus. Sed molestie pretium ex, et bibendum quam pretium consectetur. Donec id gravida massa. Donec eu magna ornare, bibendum urna at, fermentum ligula.',
  'Sed egestas tellus et felis tincidunt, vel dapibus nisi egestas. Pellentesque sit amet rutrum tellus, ut luctus felis. Suspendisse ultricies, arcu vitae tristique volutpat, erat libero lobortis sapien, ac commodo urna neque at ante. Aenean id ultrices lorem. Nullam id bibendum mauris. Nunc mattis, elit eget rutrum pretium, ligula mi finibus nunc, vitae porta ante arcu ut magna. Cras id mattis tellus. Curabitur eget eros in augue imperdiet congue at vitae orci.',
  'Nunc mollis mi non arcu maximus, eu bibendum urna placerat. Fusce pretium tempor augue, eu rhoncus erat tincidunt quis. Aenean volutpat ut tellus ac eleifend. Sed consequat enim eu lacus hendrerit vulputate. Suspendisse scelerisque massa nec massa tincidunt porta. Fusce egestas lectus eget urna fermentum tristique. Mauris ullamcorper placerat ante, eu ornare nibh dapibus quis. Aenean egestas ultrices nibh, quis fermentum mauris vehicula at.',
  'Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Duis blandit, orci a dignissim ultricies, lacus ante sodales arcu, ut interdum mi mauris ac purus. Ut sed accumsan arcu. Proin eleifend felis in nibh dapibus, ac dignissim diam laoreet. Nulla risus tortor, lobortis vitae faucibus sit amet, pretium id leo. Curabitur vestibulum sodales ipsum eget bibendum. Duis accumsan congue arcu, a laoreet mi molestie maximus. Aenean arcu eros, finibus a vestibulum quis, sodales eget ligula. Suspendisse volutpat ut lorem et aliquam. In iaculis at sem nec mollis. Nunc pulvinar ipsum sit amet semper hendrerit.',
  'Mauris tristique tellus dolor, quis faucibus arcu condimentum sit amet. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Curabitur in mi at metus gravida laoreet in vel eros. Mauris sodales nisl ut leo dignissim, et sagittis leo posuere. Sed accumsan a arcu quis posuere. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris eu velit faucibus, venenatis lacus a, posuere dolor. Pellentesque vulputate volutpat lacus nec volutpat.',
  'Pellentesque elit ipsum, semper at gravida sed, fringilla eget sem. Donec nibh ante, bibendum nec condimentum facilisis, tempor vel enim. Praesent quis erat posuere, eleifend nunc at, cursus orci. In maximus facilisis quam, eu sollicitudin mauris condimentum vel. Nulla vel turpis tincidunt, auctor leo at, fringilla purus. Quisque ullamcorper fringilla rhoncus. Sed in pulvinar nisl. Duis quis consectetur tortor, vitae mattis metus. Aenean neque dui, tincidunt ac libero eu, maximus tincidunt quam. Ut aliquam dictum sodales. Sed vel molestie dui.'
];

function randomDescription() {
  var count = Math.floor(Math.random() * 3) + 1;

  var description = '';
  for (var i = 0; i < count; ++i) {
    description += descriptions[Math.floor(Math.random() * descriptions.length)];
  }
  return description;
}

var sampleReviews = [
  {
    name: "Viktor Sigurdsson",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Ragna Ingolfsson",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Blythe Yancy",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Gisèle Swindlehurst",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Charley Eldred",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Prokopis Zeghers",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Matthias William",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Tottie Millard",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Cree Wyman",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: 5
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Ally Hummel",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Gosse Benbow",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  },
  {
    name: "Hortense Milburn",
    date: randomDate(),
    responses: {
      reviewDetail: randomDescription(),
      rating: randomRating()
    },
    contentProvider: randomProvider(),
    url: "http://www.example.com/",
    location: "123 6th St. Melbourne, FL 32904"
  }
];

module.exports = function getSampleReviews(minRating, count) {
  count = count || 10;
  minRating = minRating || 0;

  var found = [], iterationGuard = 0;
  while (found.length < count && iterationGuard++ < 100) {
    let item = sampleReviews[Math.floor(Math.random() * sampleReviews.length)];
    if (item.responses.rating >= minRating) {
      found.push(item);
    }
  }

  return found;
};
